import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Layout from "components/sales/layout/layout";
import FilesListView from "components/brandActivation/viewDetails/filesList/filesList"
import localization from "assets/localization/localization";
import Notfound from "pages/notfound";
import ReactPaginate from "react-paginate";

const KnowledgeCenter = ({
  viewDocsList = null,
  getDocsList,
  match
}) => {
  const [dataList, setDataList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isRender, setIsRender] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const res = await getDocsList();
      setIsLoading(false);
      setCurrentPage(1);
      if (res === false) {
        setIsRender(true);
      }
      else setIsRender(false);
    })();
  }, [getDocsList]);

  useEffect(() => {
    if (viewDocsList !== null && viewDocsList?.resultSets) {
      setDataList(viewDocsList.resultSets);
      setPageCount(Math.ceil(viewDocsList.total / viewDocsList.per_page));
    }
    else setIsRender(false);
  }, [viewDocsList]);

  const onPageChange = async (val) => {
    setIsLoading(true);
    const res = await getDocsList(val.selected + 1);
    setIsLoading(false);
    if (res === false) {
      setIsRender(true);
    }
    else setIsRender(false);
  };

  return isRender ? (
    <Notfound />
  ) : (
    <Layout title={localization.knowledgeCenter} isLoading={isLoading}>
        <FilesListView data={dataList} />
        {pageCount > 0 && (
          <div className="panel-pagination-col panel-table-pagination">
            <ReactPaginate
              previousLabel={"<"}
              nextLabel={">"}
              breakLabel={"..."}
              breakClassName={"break-me"}
              pageCount={pageCount}
              forcePage={currentPage - 1}
              pageRangeDisplayed={5}
              onPageChange={onPageChange}
              activeClassName={"active"}
            />
          </div>
        )}
    </Layout>
  );
};

KnowledgeCenter.propTypes = {
  viewProducts: PropTypes.object,
  getProducts: PropTypes.func,
  match: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};

export default KnowledgeCenter;
